var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitezianki(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120.998,
    height: 92,
    viewBox: "0 0 120.998 92"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bg",
    x: 0,
    y: 0,
    width: 120.998,
    height: 92,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2248",
    "data-name": "Rectangle 2248",
    width: 74.531,
    height: 38.963,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2245",
    "data-name": "Rectangle 2245",
    width: 4.666,
    height: 4.315,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SWITEZIANKI",
    transform: "translate(-884.318 -417.921)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 884.32, 417.92)",
    filter: "url(#bg)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg-2",
    "data-name": "bg",
    d: "M20045.318,14270.92h15l-7.5,10Zm-35,0v-46h85v46Z",
    transform: "translate(-19992.32 -14212.92)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SWITEZIANKI_logo",
    transform: "translate(-7.791 11.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-05290a982c8d154154f4cd7171d275d0",
    transform: "translate(916.141 424.664)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M30.911,67.81v.028l-2.061,6.65h-.174l-1.554-4.3a7.661,7.661,0,0,1-.239-.749,7.086,7.086,0,0,1-.227.749l-1.589,4.3h-.177l-2.049-6.65V67.81h.6l1.315,4.352c.087.311.193.622.28,1a10.189,10.189,0,0,1,.311-.992l1.439-4h.168l1.387,3.8c.149.41.28.818.386,1.2.106-.392.218-.79.311-1.132L30.3,67.826Z",
    transform: "translate(-15.739 -46.729)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2239",
    "data-name": "Rectangle 2239",
    width: 0.644,
    height: 6.631,
    transform: "translate(17.997 21.081)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M71.989,68.394H69.95v6.047h-.644V68.394H67.27V67.81h4.719Z",
    transform: "translate(-46.357 -46.729)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M96.625,73.854v.588H92.58V67.81h3.958v.584H93.224v2.36h2.913v.575H93.224v2.524Z",
    transform: "translate(-63.798 -46.729)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M114.62,74.245l3.314-5.207c.137-.214.264-.429.42-.653h-3.569V67.81h4.5v.2l-3.333,5.254c-.127.2-.255.4-.4.6H119.4v.584H114.62Z",
    transform: "translate(-78.986 -46.729)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2240",
    "data-name": "Rectangle 2240",
    width: 0.644,
    height: 6.631,
    transform: "translate(43.717 21.081)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M158.921,74.309v.022h-.672l-.7-1.523h-3.6l-.7,1.523h-.675v-.022l3.081-6.659h.215Zm-3.544-4.641L154.2,72.223h3.09l-1.163-2.555c-.137-.283-.255-.575-.37-.886-.127.311-.233.594-.37.886",
    transform: "translate(-105.138 -46.619)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M188.389,67.7v6.678h-.283l-4.125-4.856c-.146-.174-.311-.361-.479-.544a5.905,5.905,0,0,1,.031.622v4.729h-.644V67.65h.274l4.113,4.837c.155.174.311.361.488.553-.019-.242-.019-.476-.019-.69V67.687Z",
    transform: "translate(-126.032 -46.619)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M217.73,74.41v.031h-.808l-3.159-3.131v3.131h-.644V67.81h.644v3.131l2.994-3.131h.79v.028l-3.14,3.267Z",
    transform: "translate(-146.864 -46.729)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2241",
    "data-name": "Rectangle 2241",
    width: 0.644,
    height: 6.631,
    transform: "translate(73.888 21.081)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M1.216,74.479H0V73.9H1.216A1.141,1.141,0,0,0,2.35,72.76V69.592A1.728,1.728,0,0,1,4.079,67.87H5.285v.581H4.079a1.138,1.138,0,0,0-1.135,1.141V72.76a1.725,1.725,0,0,1-1.729,1.719",
    transform: "translate(0 -46.77)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2242",
    "data-name": "Rectangle 2242",
    width: 0.591,
    height: 1.107,
    transform: "translate(4.129 19.262)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M85.789,31.188a2.739,2.739,0,1,1,2.739-2.739,2.739,2.739,0,0,1-2.739,2.739m0-4.974a2.241,2.241,0,1,0,2.242,2.241,2.241,2.241,0,0,0-2.242-2.241",
    transform: "translate(-57.231 -17.717)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M89.777,22.928H89.05v-.51h.727a1.141,1.141,0,0,0,1.138-1.138V18.212a1.635,1.635,0,0,1,1.635-1.632h.712v.494h-.712a1.138,1.138,0,0,0-1.138,1.138v3.068a1.635,1.635,0,0,1-1.635,1.648",
    transform: "translate(-61.366 -11.426)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2243",
    "data-name": "Rectangle 2243",
    width: 0.497,
    height: 1.069,
    transform: "translate(30.697 3.342)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198",
    transform: "translate(29.873 7.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M100.405,27.715,96.09,23.4h4.576v.5H97.287l3.469,3.466Z",
    transform: "translate(-96.09 -23.4)",
    fill: "#00a499"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M114.636,12.124l-1.3-1.3a6.746,6.746,0,0,1,0-9.529L114.636,0l1.306,1.3a6.746,6.746,0,0,1,0,9.529Zm0-11.431-.951.951a6.239,6.239,0,0,0,0,8.826l.951.954.967-.945a6.239,6.239,0,0,0,0-8.826Z",
    transform: "translate(-76.742)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2246",
    "data-name": "Rectangle 2246",
    width: 0.497,
    height: 11.388,
    transform: "translate(37.645 2.002)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M137.5,24.7l-.839-.839a4.06,4.06,0,0,1,0-5.745l.839-.839.839.839a4.06,4.06,0,0,1,0,5.745Zm0-6.724-.488.488a3.569,3.569,0,0,0,0,5.046L137.5,24l.488-.488a3.569,3.569,0,0,0,0-5.046Z",
    transform: "translate(-93.354 -11.908)",
    fill: "#00a499"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2247",
    "data-name": "Rectangle 2247",
    width: 0.497,
    height: 6.137,
    transform: "translate(43.9 7.25)",
    fill: "#00a499"
  }))))));
}
export default "data:image/svg+xml;base64,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";
export { SvgSwitezianki as ReactComponent };